export enum DocumentCategory {
  eForm = 1,
  Document = 2,
}
